export enum VbAnnualDetailsProvenanceTypeEnum {
  Actual = 1,
  Estimated = 2
}
